import React from "react";
import styled from 'styled-components';

import Chartable from "../../interfaces/Chartable";
import Scalable from '../../interfaces/Scalable';
import {useTranslation} from "react-i18next";


const StyledAxis = styled.line`
  stroke-width: 2px;
  stroke-linecap: round;
`;

const VerticalLabel = styled.text`
  font-size: 0.8rem;
  font-family: MapfreText-Light;
`;

const DashedGridline = styled.line`
  stroke-width: 0.5px;
  stroke-linecap: butt;
  stroke-dasharray: 6 6;
`;


interface VerticalAxisProps extends Scalable, Chartable {
  ticks: number[],
  formatTicks?: (n: number) => string,
}


const VerticalAxis: React.FC<VerticalAxisProps> = (props: VerticalAxisProps) => {
  const margins = props.margins;
  const paddings = props.paddings;
  const dimensions = props.dimensions;

  const { i18n } = useTranslation();
  const getCurrentLng = () => i18n.language || window.localStorage.i18nextLng || 'es';

  return (
    <React.Fragment>
      <g>
        <StyledAxis
            key='left-axis'
            x1={ margins.left }
            x2={ margins.left }
            y1={ margins.top }
            y2={ margins.top + dimensions.height }
          />
        <StyledAxis
            key='right-axis'
            x1={ margins.left + dimensions.width }
            x2={ margins.left + dimensions.width }
            y1={ margins.top }
            y2={ margins.top + dimensions.height }
          />
      </g>
      <g>
        { props.ticks.map(tick => {
            return (
              <React.Fragment key={ `fragment-${ tick }` }>
                <VerticalLabel
                    x='0'
                    y={ props.yScale(tick) }
                    key={ `vertical-label-${ tick }` }
                  >
                  {
                    props.formatTicks
                      ? props.formatTicks(tick)
                      : new Intl.NumberFormat(getCurrentLng() === 'es' ? 'de' : getCurrentLng()).format(tick)
                  }
                </VerticalLabel>
                <DashedGridline
                    x1={ margins.left + paddings.left }
                    x2={ margins.left + dimensions.width - paddings.right }
                    y1={ props.yScale(tick) }
                    y2={ props.yScale(tick) }
                    key={ `gridline-${ tick }` }
                  />
              </React.Fragment>
            );
          })
        }
      </g>
    </React.Fragment>
  )
};

export default VerticalAxis;
